import { render, staticRenderFns } from "./EventDefine.vue?vue&type=template&id=1dfb350e&scoped=true&"
import script from "./EventDefine.vue?vue&type=script&lang=js&"
export * from "./EventDefine.vue?vue&type=script&lang=js&"
import style0 from "./EventDefine.vue?vue&type=style&index=0&id=1dfb350e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb350e",
  null
  
)

export default component.exports